<div class="team-main-container">
  <div *ngIf="creditCardMode || !bothAvailable" class="credit-card-layout">
    <div class="membership__form-wrapper card-verification">
      <div
        [ngClass]="{
          show: validatingCard || isCardInvalid,
          warning: isCardInvalid,
          success: isCardValid
        }"
        class="card-verification-process"
      >
        <div class="card-verification-message">
          {{ cardErrorMessage || 'Validating card...' }}
        </div>
      </div>
      <form [formGroup]="cardVerification">
        <div class="form-row">
          <div class="form-row-input">
            <span class="p-float-label">
              <p-inputmask
                id="cc-number"
                #cardNumber
                (onBlur)="setCvcMaxLength()"
                (onInput)="setCardMaxLength($event)"
                [autoClear]="false"
                [style]="{ 'letter-spacing': '0.1rem' }"
                tabindex="0"
                [unmask]="true"
                autocomplete="cc-number"
                class="input-primary sm full-width"
                formControlName="cardNumber"
                mask="9999 9999 9999 9999"
                name="creditCardNumber"
                slotChar=""
              ></p-inputmask>
              <label for="cc-number" translate> Card Number </label>
            </span>
            <div
              *ngIf="cardVerification.controls.cardNumber.errors?.pattern"
              class="error-sign"
              translate
            >
              Card number is invalid
            </div>
          </div>
        </div>
        <div class="form-row triple">
          <div class="form-row-input">
            <span *ngIf="!isSafari" class="p-float-label">
              <p-autoComplete
                id="expdate"
                [dropdown]="true"
                [tabindex]="1"
                dropdownMode="current"
                [minLength]="2"
                [maxlength]="2"
                scrollHeight="100px"
                [required]="true"
                (completeMethod)="completeMethod($event, 'month')"
                [suggestions]="monthList"
                optionLabel="label"
                dataKey="value"
                [completeOnFocus]="true"
                name="expdate"
                autocomplete="cc-exp-month"
                formControlName="month"
                styleClass="new-autocomplete-blue sm"
                type="text"
              >
              </p-autoComplete>
              <label for="expdate" translate
              ><span class="hidden">Expiration Month</span>Month</label
              >
            </span>
            <span *ngIf="isSafari" class="p-float-label">
              <label
                for="expdate2"
                [ngClass]="{ 'custom-label': isExpDateActive }"
              ><span class="hidden">Expiration Month</span>Month</label
              >
              <input
                id="expdate2"
                pInputText
                appNoLeadingSpace
                class="input-primary sm"
                tabindex="5"
                maxlength="2"
                placeholder=""
                name="expdate"
                type="text"
                formControlName="month"
              />
            </span>
            <div
              *ngIf="cardVerification.controls.month.errors?.pattern"
              class="error-sign"
              translate
            >
              Wrong month
            </div>
          </div>

          <div class="form-row-input">
            <span class="p-float-label">
              <p-autoComplete
                id="cc-exp-year"
                [dropdown]="true"
                [tabindex]="2"
                dropdownMode="current"
                [minLength]="4"
                [maxlength]="4"
                scrollHeight="100px"
                [required]="true"
                [baseZIndex]="100001"
                (completeMethod)="completeMethod($event, 'year')"
                [suggestions]="yearList"
                field="label"
                dataKey="value"
                [completeOnFocus]="true"
                autocomplete="cc-exp-year"
                name="cc-exp-year"
                formControlName="year"
                styleClass="new-autocomplete-blue sm"
                type="text"
              >
              </p-autoComplete>
              <label for="cc-exp-year" translate
              ><span class="hidden">Expiration Year</span>Year</label
              >
            </span>
            <div
              class="error-sign"
              *ngIf="cardVerification.controls.year.errors?.pattern"
              translate
            >
              Wrong year
            </div>
          </div>
          <div class="form-row-input">
            <span class="p-float-label">
              <input
                id="cc-csc"
                appNoLeadingSpace
                autocomplete="cc-csc"
                [maxlength]="cvcMaxLength"
                [minlength]="cvcMaxLength"
                [tabindex]="3"
                class="input-primary sm full-width"
                formControlName="cvc"
                name="cvv2"
                pInputText
                type="password"
              />
              <label for="cc-csc" translate>CVC</label>
            </span>
            <div
              class="error-sign"
              *ngIf="cardVerification.controls.cvc.errors?.pattern"
              translate
            >
              Wrong cvc code
            </div>
          </div>
        </div>
      </form>
    </div>

    <div *ngIf="cardManualError" class="error-sign text-center">
      {{ cardManualError }}
    </div>

    <div
      class="other-payment-option box-bottom-border link"
      *ngIf="bothAvailable"
      [ngClass]="{
        'disable-events disabled': importCardDetail,
        green: !importCardDetail
      }"
      (click)="changePaymentOption()"
    >
      Other payment options
    </div>

    <div
      [ngClass]="{
        'mt-30': !bothAvailable && !cardError,
        'mt-25': !bothAvailable && cardError
      }"
      class="footer-section"
    >
      <div class="grid justify-content-even align-items-center mt-15 mb-3">
        <button
          (click)="validateCard()"
          [disabled]="isButtonDisabled"
          class="button-simple shock-pink sm-35 fix-width margin-centered"
        >
          {{ importCardDetail ? 'Update' : 'Save' }}
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="!creditCardMode && bankAccountForm && bothAvailable">
    <h2 *ngIf="!creditCardMode" class="membership__title">
      Enter ACH Information
      <img
        *ngIf="isACHValid"
        alt="verified"
        class="card_veirifed"
        src="assets/images/verified.svg"
      />
    </h2>
    <div class="layout-card ach-information">
      <app-bank-account-thumbnail
        *ngIf="!editBankAccountMode && importBankDetail"
        [model]="importBankDetail"
      >
      </app-bank-account-thumbnail>
      <form
        *ngIf="editBankAccountMode || !importBankDetail"
        [formGroup]="bankAccountForm"
      >
        <div
          [ngClass]="{
            show: validatingCard || isCardInvalid,
            warning: isCardInvalid,
            success: isCardValid
          }"
          class="card-verification-process"
        >
          <div class="card-verification-message">
            {{ cardErrorMessage || 'Validating account...' }}
          </div>
        </div>

        <div class="form-row-input">
          <span class="p-float-label">
            <input
              id="account_holder_name"
              [tabindex]="1"
              appNoLeadingSpace
              class="input-primary sm full-width"
              formControlName="account_holder_name"
              pInputText
              type="text"
            />
            <label for="account_holder_name" translate
            >Account Holder Name *</label
            >
          </span>
          <div
            *ngIf="bankAccountForm.controls.account_holder_name.errors"
            class="error-sign"
            translate
          >
            <div
              *ngIf="
                bankAccountForm.controls.account_holder_name.errors.pattern
              "
              translate
            >
              err_only_characters_allowed
            </div>
          </div>
        </div>
        <div class="form-row-input">
          <span class="p-float-label">
            <p-select
              id="account_holder_type"
              [options]="holderType"
              [placeholder]="'label_select' | translate"
              formControlName="account_holder_type"
              styleClass="input-primary sm full-width"
            ></p-select>
            <label for="account_holder_type" translate>
              Account Holder Type *
            </label>
          </span>
          <div
            *ngIf="bankAccountForm.controls.account_holder_type.errors"
            class="error-sign"
            translate
          >
            <div
              *ngIf="
                bankAccountForm.controls.account_holder_type.errors.pattern
              "
              translate
            >
              err_required_label_account_holder_type
            </div>
          </div>
        </div>
        <div class="form-row-input">
          <span class="p-float-label">
            <input
              id="label_routing_number"
              [tabindex]="2"
              appNoLeadingSpace
              autocomplete="off"
              class="input-primary sm full-width address-border"
              formControlName="routing_number"
              maxlength="9"
              minLength="8"
              pInputText
              pKeyFilter="int"
              type="text"
            />
            <label for="label_routing_number" translate>Routing Number *</label>
          </span>
          <div
            *ngIf="bankAccountForm.controls.routing_number.errors"
            class="error-sign"
            translate
          >
            <div
              *ngIf="bankAccountForm.controls.routing_number.errors.pattern"
              translate
            >
              err_only_numerics_allowed
            </div>
          </div>
        </div>
        <div class="form-row-input">
          <span class="p-float-label">
            <input
              id="account_number"
              #accNumber
              [tabindex]="3"
              appNoLeadingSpace
              autocomplete="off"
              class="input-primary sm full-width address-border"
              formControlName="account_number"
              maxlength="12"
              pInputText
              pKeyFilter="int"
              type="text"
            />
            <label for="account_number" translate> Account Number * </label>
          </span>
          <div
            *ngIf="
              bankAccountForm.controls.account_number.errors &&
              bankAccountForm.controls.account_number.errors.pattern
            "
            class="error-sign"
            translate
          >
            err_only_numerics_allowed
          </div>
        </div>
        <div class="form-row-input">
          <span class="p-float-label">
            <input
              id="confirm_account_number"
              #accNumber
              [tabindex]="4"
              appNoLeadingSpace
              autocomplete="off"
              class="input-primary sm full-width address-border"
              formControlName="confirm_account_number"
              maxlength="12"
              pInputText
              pKeyFilter="int"
              type="text"
            />
            <label for="confirm_account_number" translate>
              Verify Account Number *
            </label>
          </span>
          <div *ngIf="!bankAccountForm.valid" class="error-sign">
            All fields are required
          </div>
        </div>
        <div
          *ngIf="
            submitted &&
            (bankAccountForm.controls.confirm_account_number.dirty ||
              bankAccountForm.controls.confirm_account_number.touched) &&
            bankAccountForm.controls.confirm_account_number.value !==
              bankAccountForm.controls.account_number.value &&
            !bankAccountForm.controls.confirm_account_number.errors.required
          "
          class="form-errors"
          translate
        >
          err_confirm_account_number_not_match
        </div>
      </form>
    </div>
    <div
      (click)="changePaymentOption()"
      [ngClass]="{
        'disable-events disabled': importBankDetail,
        green: !importBankDetail
      }"
      class="other-payment-option box-bottom-border link"
    >
      Other payment options
    </div>

    <div class="grid justify-content-even align-items-center mt-15 mb-2">
      <button
        (click)="
          !editBankAccountMode && importBankDetail
            ? editBankAccount(true)
            : validateBankAccount()
        "
        [disabled]="submitted && !bankAccountForm.valid"
        class="button-simple shock-pink sm-35 fix-width"
      >
        {{ !editBankAccountMode && importBankDetail ? 'Edit' : 'Save' }}
      </button>
      <button
        (click)="deleteBankAccount()"
        class="button-simple bg-pink sm-35 fix-width"
      >
        Delete
      </button>
    </div>
  </div>
</div>
